/**
 * SGG Product Card Image Carousel
 * – Hover to advance images (desktop)
 * – Swipe to navigate (mobile)
 * – Dot indicators
 * – Auto-advance on hover every 2.5s
 */
(function () {
  'use strict';

  const AUTOPLAY_MS = 2500;

  function initCarousel(el) {
    const track = el.querySelector('[data-sgg-carousel-track]');
    const dots = el.querySelectorAll('[data-dot-index]');
    const slides = el.querySelectorAll('[data-slide-index]');
    if (!track || slides.length < 2) return;

    let current = 0;
    let autoTimer = null;
    let touchStartX = 0;
    let touchDiffX = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      var slideWidth = el.offsetWidth;
      track.style.transform = 'translateX(-' + (current * slideWidth) + 'px)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function next() {
      goTo(current + 1);
    }

    function startAutoplay() {
      stopAutoplay();
      autoTimer = setInterval(next, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    // Dot clicks
    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(parseInt(dot.getAttribute('data-dot-index'), 10));
        stopAutoplay();
        startAutoplay();
      });
    });

    // Desktop hover – auto-advance while hovering
    el.addEventListener('mouseenter', function () {
      startAutoplay();
    });

    el.addEventListener('mouseleave', function () {
      stopAutoplay();
      // Reset to first image when mouse leaves
      goTo(0);
    });

    // Touch / swipe support
    el.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchDiffX = 0;
      el.classList.add('is-touched');
      stopAutoplay();
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      touchDiffX = e.touches[0].clientX - touchStartX;
    }, { passive: true });

    el.addEventListener('touchend', function () {
      if (Math.abs(touchDiffX) > 40) {
        if (touchDiffX < 0) {
          goTo(current + 1);
        } else {
          goTo(current - 1);
        }
      }
      // Keep dots visible on mobile for a bit
      setTimeout(function () {
        el.classList.remove('is-touched');
      }, 2000);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sgg-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
